<template>
  <div>
    <!-- begin breadcrumb -->
    <breadcrumb activeName="订单商品评价" :breadcrumbItem="[{to:'/orders/list',name:'订单列表'}]"></breadcrumb>

    <!-- begin page-header -->
    <h1 class="page-header">
      订单商品评价
      <small>用户评价的列表...</small>
    </h1>
    <!-- end page-header -->
    <panel title="订单评价列表">
      <Row :gutter="5">
        <Col span="5">
          <Input v-model="filterCond.goods_name" placeholder="商品名称"></Input>
        </Col>
        <Col span="4">
          <DatePicker
            v-model="orderdate"
            format="yyyy-MM-dd"
            type="daterange"
            placement="bottom-end"
            placeholder="评价日期"
            style="width: 100%"
          ></DatePicker>
        </Col>
        <Col span="3">
          <Select v-model="filterCond.status">
            <Option :value="99">不限制</Option>
            <Option :value="0">未审批</Option>
            <Option :value="1">审批通过</Option>
            <Option :value="-1">审批不通过</Option>
          </Select>
        </Col>
        <Col span="3">
          <Button type="primary" class="btn btn-theme" @click="fn_query">查询</Button>
        </Col>
      </Row>
      <Table class="m-t-10" :columns="columns" :data="datas">
        <template slot="order_sn" slot-scope="{row}">{{row.order.order_sn}}</template>
        <template slot="ordergoods" slot-scope="{row}">
          <p
            v-for="(item,index) in row.order.ordergoods"
            :key="index"
          >{{item.goods_name}} {{item.goods_number}} * ￥{{item.promotion_price}}</p>
        </template>
        <template slot="comments" slot-scope="{row}">
          <Card :bordered="false">
            <p>{{row.user_name}} {{row.created_at}}</p>
            <!-- <p>评价: {{row.commentscore}}</p> -->
            <p>
              商品评价:
              <Icon type="ios-star" v-for="n in row.goodsscore" :key="n"></Icon>
            </p>
            <p v-if="row.servicescore>0">
              服务评价:
              <Icon type="ios-star" v-for="n in row.servicescore" :key="n"></Icon>
            </p>
            <p v-if="row.deliveryspeedscore >0">
              发货评价:
              <Icon type="ios-star" v-for="n in row.deliveryspeedscore" :key="n"></Icon>
            </p>

            <p>内容: {{row.content}}</p>
            <div class="row">
              <div class="col-md-4" v-for="(item,k) in row.images" :key="k">
                <img
                  :src="logourl + item"
                  style="max-width:100%;max-height:100%;width:auto;height:auto"
                />
              </div>
            </div>
          </Card>
        </template>
        <template slot="status" slot-scope="{row}">
          <span v-if="row.status ==0">未审批</span>
          <span v-else-if="row.status == 1" style="color:green">审批通过</span>
          <span v-else-if="row.status == -1" style="color:red">审批不通过</span>
        </template>
        <template slot="action" slot-scope="{row}">
          <button type="button" class="btn btn-theme m-r-10" @click="fn_approve(row,1)">审批通过</button>
          <button type="button" class="btn btn-danger" @click="fn_approve(row,-1)">审批不通过</button>
        </template>
      </Table>
      <Page
        style="margin-top:10px"
        :total="totalRows"
        :current="filterCond.page"
        :page-size="filterCond.pageNum"
        show-total
        show-elevator
        @on-change="fn_switchPage"
      />
    </panel>
  </div>
</template>
<script>
import breadcrumb from "@/components/breadcrumb";
import { getOrderCommentsList, submitCommentsIssue } from "@/api/order";

import config from "@/config";
import moment from "moment";
export default {
  components: { breadcrumb },
  data() {
    return {
      logourl: config.baseUrl.imageurl,
      orderdate: [],
      filterCond: {
        begindate: "",
        enddate: "",
        goods_name: "",
        status: 0,
        page: 1,
        pageNum: 10
      },
      columns: [
        {
          title: "#ID",
          key: "id",
          width: 50
        },
        {
          title: "订单号",
          slot: "order_sn",
          width: 180
        },
        {
          title: "订单商品",
          slot: "ordergoods"
        },
        {
          title: "评价内容",
          slot: "comments"
        },
        {
          title: "状态",
          slot: "status",
          width: 100
        },
        {
          title: "操作",
          slot: "action",
          width: 200
        }
      ],
      datas: [],
      totalRows: 0
    };
  },
  mounted() {
    this.fn_load(this.filterCond);
  },
  methods: {
    fn_show_order(row) {
      //   console.log(row);
    },
    fn_query() {
      this.filterCond.page = 1;
      this.fn_load(this.filterCond);
    },
    fn_load(filterCond) {
      if (this.orderdate.length > 0) {
        this.filterCond.begindate = moment(this.orderdate[0]).format(
          "YYYY-MM-DD"
        );
        this.filterCond.enddate = moment(this.orderdate[1]).format(
          "YYYY-MM-DD"
        );
      } else {
        this.filterCond.begindate = "";
        this.filterCond.enddate = "";
      }
      getOrderCommentsList(filterCond)
        .then(res => {
          this.datas = res.data.data;
          this.totalRows = res.data.total;
        })
        .catch(error => {
          this.$Message.error(error);
        });
    },
    fn_switchPage(page) {
      this.filterCond.page = page;
      this.fn_load(this.filterCond);
    },
    fn_approve(row, status) {
      let data = {
        id: row.id,
        status: status
      };
      submitCommentsIssue(data)
        .then(res => {
          if (res.data.code == 200) {
            this.$Notice.success(res.data);
            row.status = status;
          } else {
            this.$Notice.error(res.data);
          }
        })
        .catch(error => {
          this.$Message.error(error);
        });
    }
  }
};
</script>